import { MuiThemeProvider } from '@material-ui/core/styles';
import jwtDecode from "jwt-decode";
import React from 'react';
import { Detector } from "react-detect-offline";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import { StripeProvider } from 'react-stripe-elements';
import { configureAws, configureAxios, configureFontAwesomeIcons } from '../config';
import { store } from "../store";
import { setAuthorizationToken, setCurrentUser } from "../store/actions/auth";
import { theme } from '../theme';
import Main from "./Main";
configureFontAwesomeIcons();
configureAxios();
configureAws();


if (localStorage.jwtToken) {
  setAuthorizationToken(localStorage.jwtToken)
  try {
    store.dispatch(setCurrentUser(jwtDecode(localStorage.jwtToken)))
  } catch(err) {
    store.dispatch(setCurrentUser({}))
  }
}

//process.env.REACT_APP_STRIPE_PROVIDER

const App = () => (
  <StripeProvider apiKey={process.env.REACT_APP_STRIPE_PROVIDER || 'stripe'}>
    <Provider store={store}>
      <Router >
        <div data-testid="onboarding" className="onboarding">
          <MuiThemeProvider theme={theme}>
            <Main />
            {/* <Detector
              render={({ online }) => !online && (
                <div className={"system-offline"}>
                  You are currently offline. Please check your internet connection and refresh the page.
                </div>
              )}
            /> */}
          </MuiThemeProvider>
        </div>
      </Router>
    </Provider>
  </StripeProvider>
)

export default App;



// WEBPACK FOOTER //
// ./src/containers/App.js